import "core-js/modules/es.array.index-of";

/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { FormattedMessage } from 'react-intl';
import { isMobileDevice } from 'helpers/isMobile';
export var DeviceUnsupported = function DeviceUnsupported(_ref) {
  var handleStandardPlay = _ref.handleStandardPlay;
  return React.createElement("div", {
    className: "modal__device-unsupported"
  }, React.createElement("div", {
    className: "modal__device-setup__top"
  }, React.createElement(FormattedMessage, {
    id: "device.unsupported-header",
    defaultMessage: "Browser not supported",
    tagName: "h3"
  }), React.createElement(FormattedMessage, {
    id: "device.unsupported-browser",
    className: "mb0",
    defaultMessage: "The interactive workout experience is currently only supported in the Google Chrome browser for Mac or Windows 10.",
    tagName: "p"
  })), React.createElement("div", {
    className: "modal__device-setup__content"
  }, React.createElement("img", {
    src: require('../../../static/img/chrome-logo.png'),
    alt: "chrome",
    className: "modal__device-unsupported__chrome-logo"
  })), !isMobileDevice() && navigator && navigator.platform.indexOf('Mac') !== -1 && React.createElement("a", {
    href: "https://www.google.com/chrome/",
    target: "_blank",
    rel: "noopener noreferrer",
    className: "bt bt--primary bt--solid"
  }, React.createElement(FormattedMessage, {
    id: "device.launch.chrome",
    defaultMessage: "Get the Chrome browser"
  })), React.createElement(Link, {
    onClick: handleStandardPlay,
    className: "block pl- mt+"
  }, React.createElement(FormattedMessage, {
    id: "play.video",
    defaultMessage: "Watch video only"
  })));
};
DeviceUnsupported.propTypes = {
  handleStandardPlay: PropTypes.func
};